import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import InputLabel from '../ui/InputLabel'

const Ofertas = ({ values, onChange, vieneDeAdministrar }) => {
  const inicializado = useRef(false)
  useEffect(() => {
    if (
      !inicializado.current &&
      vieneDeAdministrar &&
      Number(values.porcDctoPublicacion) > 0 &&
      (values.porcDcto === undefined || values.porcDcto === null)
    ) {
      onChange(
        {
          target: { name: 'porcDcto', value: values.porcDctoPublicacion, type: 'number' }
        },
        'num'
      )
      inicializado.current = true
    }
  }, [vieneDeAdministrar, values.porcDctoPublicacion, values.porcDcto, onChange])

  function fechaLegible(fecha) {
    if (
      !fecha ||
      fecha === '0001-01-01T00:00:00' ||
      fecha === '0001-01-01' ||
      fecha === null
    ) {
      return ''
    }
    if (fecha.includes('T')) {
      return fecha.split('T')[0].split('-').reverse().join('/')
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
      return fecha.split('-').reverse().join('/')
    }
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
      return fecha
    }
    return fecha
  }

  const precioFinal =
    !isNaN(Number(values.porcDcto)) && !isNaN(Number(values.precioUnitario))
      ? Number(values.porcDcto) === 0
        ? Number(values.precioUnitario)
        : Number(values.precioUnitario) -
          (Number(values.porcDcto) * Number(values.precioUnitario)) / 100
      : ''

  function normalizarFechaInput(fecha) {
    if (!fecha) {
      return ''
    }
    if (fecha.includes('T')) {
      return fecha.split('T')[0]
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
      return fecha
    }
    return ''
  }

  function estaEnVigencia(desde, hasta) {
    if (!desde || !hasta) {
      return false
    }
    const hoy = new Date()
    const d = new Date(desde)
    const h = new Date(hasta)
    return d <= hoy && hoy <= h
  }

  const porcDctoPublicacion = Number(values.porcDctoPublicacion) || 0
  const porcDctoLista = Number(values.porcDctoLista) || 0
  const ofertaDesde = values.ofertaDesde || ''
  const ofertaHasta = values.ofertaHasta || ''
  const listaOfertaDesde = values.listaOfertaDesde || ''
  const listaOfertaHasta = values.listaOfertaHasta || ''

  let origen = 'Sin descuento'
  let vigencia = ''
  let porcentaje = ''
  let mostrar = false

  if (porcDctoPublicacion > 0 && estaEnVigencia(ofertaDesde, ofertaHasta)) {
    origen = 'Descuento de publicación'
    porcentaje = `${porcDctoPublicacion}%`
    vigencia =
      ofertaDesde && ofertaHasta
        ? `Vigente del ${fechaLegible(ofertaDesde)} al ${fechaLegible(ofertaHasta)}`
        : ''
    mostrar = true
  } else if (porcDctoLista > 0 && estaEnVigencia(listaOfertaDesde, listaOfertaHasta)) {
    origen = 'Descuento de lista'
    porcentaje = `${porcDctoLista}%`
    vigencia =
      listaOfertaDesde && listaOfertaHasta
        ? `Vigente del ${fechaLegible(listaOfertaDesde)} al ${fechaLegible(listaOfertaHasta)}`
        : ''
    mostrar = true
  } else {
    origen = 'Sin descuento'
    porcentaje = ''
    vigencia = ''
    mostrar = true
  }

  return (
    <>
      {!vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">
          Aquí puede incluir una oferta de tiempo limitado para su producto. Las fechas de
          Inicio y finalización son únicamente válidas para la oferta realizada.
        </p>
      )}
      <div className="row">
        <div className="col-12 col-lg-6 mb-2">
          <label className="mb-1" style={{ whiteSpace: 'nowrap' }}>
            Porcentaje de Descuento:
          </label>
          <div className="d-flex align-items-center">
            <InputLabel
              type="number"
              name="porcDcto"
              value={
                values.porcDcto === undefined || values.porcDcto === null
                  ? ''
                  : values.porcDcto
              }
              onChange={(e) => onChange(e, 'num')}
              onFocusSelected
              classNameInput="input-text-bordered w-35"
              style={{ minWidth: 80, maxWidth: 120 }}
            />
            <i
              className="fa fa-percent ml-2"
              aria-hidden="true"
              style={{ fontSize: 18 }}
            />
          </div>
        </div>
        <div className="col-12 col-lg-6 mb-2">
          <label className="mb-1" style={{ whiteSpace: 'nowrap' }}>
            Precio final de Publicación (SIN IVA):
          </label>
          <div className="d-flex align-items-center">
            <i className="fa fa-usd mr-2" aria-hidden="true" style={{ fontSize: 18 }} />
            <InputLabel
              name="precioFinal"
              value={precioFinal}
              readOnly
              classNameInput="input-text-bordered w-40"
              style={{ minWidth: 120, maxWidth: 180, textAlign: 'left' }}
            />
          </div>
        </div>
        <div className="col-6 col-lg-6">
          <div className="row">
            <div className="col">
              <InputLabel
                type="date"
                name="ofertaDesde"
                classNameInput="input-text-bordered w-40"
                value={normalizarFechaInput(values.ofertaDesde) || ''}
                onChange={onChange}
                label="Fecha de Inicio: "
                error="Completar Fecha de Inicio Oferta"
              />
            </div>
          </div>
        </div>
        <div className="col-6 col-lg-6">
          <div className="row">
            <div className="col">
              <InputLabel
                type="date"
                name="ofertaHasta"
                classNameInput="input-text-bordered w-40"
                value={normalizarFechaInput(values.ofertaHasta) || ''}
                onChange={onChange}
                label="Fecha de Finalización: "
                error="Completar Fecha de Finalización Oferta"
              />
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: 16 }}>
        {mostrar ? (
          <div className="alert alert-info" style={{ fontSize: 14 }}>
            <b>Descuento aplicado:</b> {porcentaje || 'Sin descuento'}
            <br />
            {vigencia && (
              <span>
                <b>Vigencia:</b> {vigencia}
                <br />
              </span>
            )}
            <b>Origen:</b> {origen}
          </div>
        ) : null}
      </div>
    </>
  )
}

Ofertas.propTypes = {
  values: PropTypes.shape({
    porcDcto: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    porcDctoPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    porcDctoLista: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    listaVigenciaHasta: PropTypes.string,
    listaVigenciaDesde: PropTypes.string,
    listaOfertaDesde: PropTypes.string,
    listaOfertaHasta: PropTypes.string,
    precioUnitario: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    ofertaDesde: PropTypes.string.isRequired,
    ofertaHasta: PropTypes.string.isRequired
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  vieneDeAdministrar: PropTypes.bool
}

export default Ofertas
